export default __webpack_public_path__ + "static/media/toast-success.65a9d54e.svg";